import { render, staticRenderFns } from "./CollectionViewPhoto.vue?vue&type=template&id=59c930cf&scoped=true&"
import script from "./CollectionViewPhoto.vue?vue&type=script&lang=js&"
export * from "./CollectionViewPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CollectionViewPhoto.vue?vue&type=style&index=0&id=59c930cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c930cf",
  null
  
)

export default component.exports